// src/icons/Notebook.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Notebook({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.3998 1H2.5998C2.15798 1 1.7998 1.35818 1.7998 1.8V14.2C1.7998 14.6418 2.15798 15 2.5998 15H5.3998M5.3998 1H13.3998C13.8416 1 14.1998 1.35818 14.1998 1.8V14.2C14.1998 14.6418 13.8416 15 13.3998 15H5.3998M5.3998 1V15M8.5998 4.6H10.9998M8.5998 7.8H10.9998",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  Notebook
};
